/*
 * Built with Common Launchpad 2.0.3
 newsletter
 */

import $ from 'jquery';

class Newsletter {
    constructor() {
    }

    init() {
        this.checkForOfficeInfo();
        this.bindEvents();
    }

    bindEvents() {
    }

    checkForOfficeInfo() {
        if ($('form.footer-newsletter-signup')) {
            if (typeof officeId !== 'undefined' && officeId !== undefined) {
                $('#Footer_EmailOfficeId').val(officeId);
                $('#Footer_EmailOfficeEmail').val(officeEmail);
            } else {
                $('#Footer_EmailOfficeId').val(999);
                $('#Footer_EmailOfficeEmail').val('corporate@email.com');
            }
        }
    }
}

export default Newsletter;

$(() => {
    const newsletter = new Newsletter();
    newsletter.init();
});